import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { req_edit_cslc_myparticipant } from "../../api";
import storageUtils from "../../utils/storageUtils";
import { Card, Input, message } from "antd";
const { TextArea } = Input;

class MyParticipantRegisterEditModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    participant: PropTypes.object,
  };

  state = {
    item: {
      Uid: "",
      EnrollName: "",
      EnrollCode: "",
      Department: "",
      Grade: "",
      Classroom: "",
      ContactPerson: "",
      ContactPhone: "",
      ContactEmail: "",
      Teams: "無",
      Title: "",
      Description: "",
    },
  };

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.init();
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_edit_item = async (item) => {
    item.condition = "BASE";
    const result = await req_edit_cslc_myparticipant(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success("修改成功");
    } else {
      message.error(result.message);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  init = () => {
    const participant = this.props.participant;
    this.setState({ item: participant });
  };

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.props.participant;
    const errors = [];
    if (row.Title.trim() === "") {
      errors.push("角色名稱未填寫");
    }

    if (row.Description === "") {
      errors.push("創作理念未填寫");
    }

    if (errors.length === 0) {
      //console.log(row);
      this.api_edit_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  /////////////////////////////////////////////////////////////
  render() {
    const {
      ContactPerson,
      ContactPhone,
      ContactEmail,
      Teams,
      Title,
      Description,
    } = this.props.participant;
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="col-lg-3">
              <div className="form-group">
                <label>聯絡人</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  id="ContactPerson"
                  placeholder=""
                  defaultValue={ContactPerson}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>手機電話</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  id="ContactPhone"
                  placeholder=""
                  defaultValue={ContactPhone}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-lg-5">
              <div className="form-group">
                <label>電子信箱</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  id="KeywordC"
                  placeholder="以學校官方信箱為主"
                  defaultValue={ContactEmail}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <label>團隊成員</label>
            <TextArea
              name="Teams"
              id="Teams"
              rows={4}
              placeholder="1.姓名；學號；系所班級；聯絡信箱（若需要自行新增）"
              defaultValue={Teams}
              onChange={this.handleChange}
            />
          </div>
          <div className="form-row">
            <div className="col-lg">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>角色名稱
                </label>
                <input
                  type="text"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="Title"
                  id="Title"
                  defaultValue={Title}
                  aria-describedby="mobileHelp"
                  placeholder="形象大使角色名稱"
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <label>
              <span className="text-danger">*</span>創作理念
            </label>
            <TextArea
              name="Description"
              id="Description"
              rows={4}
              placeholder="說明設計特點、人設概念與創作想法， 500字以內（如人設、星座、專長、生日、血型、特殊特色、自我介紹)"
              defaultValue={Description}
              onChange={this.handleChange}
            />
          </div>
          <div className="form-row">
            <div className="col-lg">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-warning btn-sm btn-block"
                >
                  <i className="fa fa-cog"></i>
                  <span style={{ marginLeft: "4px" }}>修改</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MyParticipantRegisterEditModal);
